'use strict';

const _ = require('lodash');

/**
 * @name FacetRepositoryOptions
 * @type {Object}
 * @property {string} type
 * @property {String} placeTypeFacetName
 */

/**
 * ファセット検索連携して、マップアプリとしてデータ表示するためのデータベースアクセサ
 * 
 * @name FacetRepository
 * @extends {Repository}
 */
export default class FacetRepository {
  /**
   * 
   * @param {FacetRepositoryOptions} options
   */
  constructor(options) {
    this.events = null;
    this.options = options;
  }
  setEvents(events) {
    this.events = events;
  }
  /**
   * 
   * @param {Request} request
   * @returns {Promise}
   */
  search(request) {

    // 円表示なしの場合は、全て検索対象にする
    if (request.radius === '0' || request.radius === '' || request.radius === 0) {
      request.radius = 100;
    }

    this.events.emit('ihBeforeSearch', request);

    if (!this.facets) {
      return Promise.resolve({places: []});
    }

    var query = this.buildFacetQuery(request);

    return this.getFacetResult(query).then((result) => {

      result = _.filter(result, function (a) {
        return a.lat && a.lng;
      });

      if (request.opt.places) {
        result = _.filter(result, function (a) {
          return _.contains(request.opt.places, a.attributes.No + "");
        })
      }
      this.searchResult = {places: result};

      return this.searchResult;
    });
  }
  setFacets(facets) {
    // 保持しておく
    this.facets = facets;

    // 施設種別ファセットを探す
    var typeFacet;
    _.forEach(this.facets, (facet) => {
      if (facet.name === this.options.placeTypeFacetName) {
        typeFacet = facet;
      }
    });

    // 施設種別がすぐに取得できるように準備しておく
    if (typeFacet) {
      this.facility_type_name_table = _.reduce(typeFacet.items, (obj, item, i) => {
        obj[i] = item.name;
        return obj;
      }, {});
      this.facility_type_name_table_inverted = _.invert(this.facility_type_name_table);
    }
  }
  /**
   * 
   * @returns {Promise.<Facet[]>}
   */
  loadFacets() {
    var url = '../facet/api/facets';

    return $.ajax({url: url, dataType: 'json'}).then((facets) => {
      facets =  _.map(facets, (facet) => {
        try{
          facet.attributes = JSON.parse(facet.attributes);
        }catch(e){

        }
        return facet;
      });

      this.setFacets(facets);

      return facets;
    });
  }
  /**
   *
   * @returns {Promise.<Facet[]>}
   */
  getFacets() {
    
    if (this.facets) {
      return Promise.resolve(this.facets);
    }
    
    return this.loadFacets();
  }
  /**
   *
   * @param {Number} id
   * @return {Facet}
   */
  getFacetByItemId(id){
    return _.find(this.facets, function(facet){
      return _.find(facet.items, function(item){
        return item.id === id;
      });
    });
  }
  getFacetCount(params){
    var url = '../facet/api/count';
    return $.ajax({url: url, dataType: 'json', data: params}).then(function(result){
      return result;
    });
  }
  buildFacetQuery(request) {
    var that = this;
    if (!request || !request.opt){
      return {};
    }
    var types = request.opt.types || [];
    return types.reduce(function(q, type){
      var facet = that.getFacetByItemId(type);
      if (facet){
        if (!q[facet.id]){
          q[facet.id] = [];
        }
        q[facet.id].push(type);
      }
      return q;
    }, {});
  }
  /**
   *
   * @param {Number} id
   * @return {Facet}
   */
  getFacetByItemId(id) {
    return _.find(this.facets, function(facet){
      return _.find(facet.items, function(item){
        return item.id === id;
      });
    });
  }
  /**
   *
   * @param params
   * @returns {Promise.<Document[]>}
   */
  getFacetResult(params) {
    var url = '../facet/api/query';
    var that = this;
    
    return new Promise((resolve, reject) => {
      
      $.ajax({url: url, dataType: 'json', data: params}).done((result) => {
        
        result = _.sortBy(result, function(r){
          if (that.sortKey === 'kana') {
            return r["動物名"];
          }else if (that.sortKey === 'mound'){
            var a = r["墳丘長（詳細）"].match(/\d+/);
            if (!a){
              return 1000;
            }
            return parseInt(a[0], 10) * that.sortOrder;
          } else if(that.sortKey === 'length') {
            var l = r['平均体長' + '(cm)'];
            if(!l || l === '未定義'){
              return 10000;
            }
            return parseInt(l, 10);
          } else if(that.sortKey === 'era'){
            var eras = {
              "古代": 1,
              "古代？": 2,
              "古代～": 3,
              "縄文～古墳": 4,
              "縄文早期～中世": 5,
              "縄文～現代": 6,
              "弥生": 7,
              "弥生～": 8,
              "弥生～奈良": 9,
              "弥生～鎌倉": 10,
              "古墳": 11,
              "古墳～": 12,
              "古墳～？": 13,
              "古墳～奈良": 14,
              "飛鳥": 15,
              "飛鳥～奈良": 16,
              "飛鳥～平安": 17,
              "飛鳥～中世": 18,
              "奈良": 19,
              "奈良？": 20,
              "白鳳": 21,
              "奈良～中世": 22,
              "平安": 23,
              "平安？": 24,
              "中世": 25,
              "鎌倉": 26,
              "室町～江戸？": 27,
              "南北朝": 28,
              "江戸": 29,
              "不明": 1000,
            };
            var a = r["時代区分"];
            if (!eras[a]){
              return 1000;
            }
            //return eras[a] * that.sortOrder;
            return eras[a];
          }
        });

        result = _.map(result, this.convertFromFacetResultItem.bind(this));
        
        resolve(result);
        
      })
      .fail((err) => {
        reject(err);
      })
      
    });
  }
  /**
   * ファセット検索システムの形式からマップシステムへマッピング
   * 
   * TODO: この定義をオプションで指定できれば汎用的に使える 
   * 
   * @param {FacetResultItem} place
   * @return {Place}
   */
  convertFromFacetResultItem(data) {
    return {
      lat: parseFloat(data["緯度"]),
      lng: parseFloat(data["経度"]),
      image: data["写真"],
      image_label: data["image_label"],
      name: data["動物名"],
      address: data["獣舎"],
      id: parseInt(data.id, 10),
      attributes: data,
      type: this.getPlaceTypeFromFacetResultItem(data),
      description: data["説明"],
      info: data['info']
    };
  }
  /**
   * ファセット検索結果から、施設種別IDを得る
   * 
   * @param {FacetResultItem} data
   */
  getPlaceTypeFromFacetResultItem(data) {
    return this.facility_type_name_table_inverted[ data[this.options.placeTypeFacetName] ];
  }

  getPlaceTypeFacet() {
    return _.find(this.facets, {name: this.options.placeTypeFacetName});
  }
  /**
   * 
   * setOptionsForPlaceTypesに渡す値を取得する
   */
  getPlaceTypes() {
    var types = _.flatten(this.facets.map((facet) => {
      return facet.items.map((item, i) => {
        i = i % 14;
        return {
          name: item.name,
          kana_search: false,
          visible: true,
          checked: false,
          help: false,
          icon_pin: i + '_pin.png',
          icon_min: i + '_ico.png',
          id: item.id,
          category: facet
        }
      });
    }));
  
    // 初期値テスト
    var type = _.find(types, function(t){
      return t.name ===  '絶滅の危機にある動物たち';
    });
    if (type){
      type.checked = true;
    }
    
    return types;

  }
  
}



// WEBPACK FOOTER //
// ./map/js/ih/repository/FacetRepository.js